import {Grid, useTheme} from "@mui/material";
import Typography from "@mui/material/Typography";

export default function FormFieldBase({label = undefined, children}) {
  const theme = useTheme();
  const style = styles(theme);

  return (
    <Grid item xs={12} sm={6} md={4} style={style.fieldContainer}>
      {label && <Typography variant="body1" style={style.labelStyle}>
        {label}
      </Typography>}
      {children}
    </Grid>
  );
}

const styles = (theme) => ({
  fieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: '100%',
    gap: theme.spacing(1),
  },
  labelStyle: {
    fontWeight: '800',
    backgroundColor: theme.brand.chrome,
    padding: '0.5rem',
    color: theme.palette.text.primary,
    borderRadius: '0.5rem'
  },
});